import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import "./Skills.css";

const skillsData = [
  { name: "HTML5", logo: "https://cdn.worldvectorlogo.com/logos/html-1.svg" },
  { name: "CSS3", logo: "https://cdn.worldvectorlogo.com/logos/css-3.svg" },
  {
    name: "Bootstrap",
    logo: "https://cdn.worldvectorlogo.com/logos/bootstrap-4.svg",
  },
  {
    name: "Tailwind CSS",
    logo: "https://cdn.worldvectorlogo.com/logos/tailwind-css-2.svg",
  },
  {
    name: "Material UI",
    logo: "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg",
  },
  {
    name: "JavaScript",
    logo: "https://cdn.worldvectorlogo.com/logos/javascript-1.svg",
  },
  {
    name: "React",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
  },
  {
    name: "NodeJS",
    logo: "https://cdn.worldvectorlogo.com/logos/nodejs-2.svg",
  },
  {
    name: "MongoDB",
    logo: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
  },
  {
    name: "MySQL",
    logo: "https://cdn.worldvectorlogo.com/logos/mysql-3.svg",
  },
  {
    name: "Firebase",
    logo: "https://cdn.worldvectorlogo.com/logos/firebase-2.svg",
  },
  { name: "Git", logo: "https://cdn.worldvectorlogo.com/logos/git-icon.svg" },
  {
    name: "Vercel",
    logo: "https://i.ibb.co.com/kmvSsCM/68747470733a2f2f6173736574732e76657263656c2e636f6d2f696d6167652f75706c6f61642f7631353838383035383538.png",
  },
  {
    name: "Netlify",
    logo: "https://cdn.worldvectorlogo.com/logos/netlify.svg",
  },
  { name: "C++", logo: "https://cdn.worldvectorlogo.com/logos/c.svg" },
  { name: "PHP", logo: "https://i.ibb.co.com/tJd8DmJ/2560px-PHP-logo-svg.png" },
];

const SkillCard = ({ name, logo }) => (
  <Col xs={6} sm={4} lg={3} className="skill-column">
    <Card className="skill-card">
      <div className="skill-icon-wrap">
        <Card.Img className="skill-icon" src={logo} alt={`${name} logo`} />
      </div>
      <Card.Body>
        <Card.Text className="skill-name">{name}</Card.Text>
      </Card.Body>
    </Card>
  </Col>
);

const Skills = () => {
  return (
    <section id="skills">
      <Container>
        <div className="skills-heading">
          <div>
            <p className="section-kicker">
              <span /> Tools of the trade
            </p>
            <h1>
              Skills &amp; <em>stack.</em>
            </h1>
          </div>
          <p className="skills-lead">A practical toolkit for turning ideas into polished, reliable products.</p>
        </div>
        <Row className="skills-grid g-3 g-md-4" data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="1500">
          {skillsData.map((skill) => (
            <SkillCard key={skill.name} {...skill} />
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Skills;
